import _ from 'lodash'

// Define types for the configuration objects
export type ConfigValue = string | number | boolean | null | ConfigObject | ConfigValue[]
export type ConfigObject = { [key: string]: ConfigValue }

// Define a type for path strings (dot notation paths)
export type ConfigPath = string

export const getValueFromBaseIfNotInDiff = (base: ConfigObject, diff: ConfigObject, path: ConfigPath): ConfigValue => {
    if (_.get(diff, path) === undefined) {
        return _.get(base, path)
    }
    return _.get(diff, path)
}
export const getValueFromBase = (base: ConfigObject, path: ConfigPath): ConfigValue => {
    return _.get(base, path)
}

export const setValueInDiff = (diff: ConfigObject | undefined, path: ConfigPath, value: ConfigValue): ConfigObject => {
    return _.set(diff || {}, path, value)
}

export const convertStateToDiff = (
    paths: Record<string, ConfigPath>,
    state: Record<string, ConfigValue>,
    diff: ConfigObject,
    base: ConfigObject
): ConfigObject => {
    const newDiff = _.cloneDeep(diff)

    Object.keys(state).forEach((keyOfState) => {
        const path = paths[keyOfState]
        const stateValue = state[keyOfState]
        const baseValue = _.get(base, path)

        // If value is the same as in base, remove it from diff
        if (_.isEqual(stateValue, baseValue)) {
            deepDelete(newDiff, path)
        } else {
            if (keyOfState === 'lot_id' && stateValue === undefined) {
                deepDelete(newDiff, path)
            } else {
                _.set(newDiff, path, stateValue)
            }
        }
    })

    return newDiff
}

// * Recursively deletes a key in a nested object and removes empty parent objects.
export function deepDelete(obj: ConfigObject, path: ConfigPath | string[] | null | undefined): ConfigObject {
    if (!obj || !path) return obj

    // Convert string path to array if needed
    const pathArray = typeof path === 'string' ? path.split('.') : [...path]

    if (pathArray.length === 0) return obj

    // For single-level deletion
    if (pathArray.length === 1) {
        delete obj[pathArray[0]]
        return obj
    }

    // For multi-level deletion
    const key = pathArray[0]
    const remainingPath = pathArray.slice(1)

    // If the key exists and is an object
    if (obj[key] && typeof obj[key] === 'object') {
        // Recursively delete from the nested object
        deepDelete(obj[key] as ConfigObject, remainingPath)

        // If the nested object is now empty, remove it
        if (Object.keys(obj[key] as ConfigObject).length === 0) {
            delete obj[key]
        }
    }

    return obj
}
